import { useState, type KeyboardEvent } from "react";
import { EyeIcon, EyeOffIcon } from "../../../shared/icons";

interface PasswordInputProps {
  value: string;
  onChange: (value: string) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  placeholder: string;
  id: string;
  autoComplete?: string;
  disabled?: boolean;
  autoFocus?: boolean;
}

export function PasswordInput({ 
  value, 
  onChange, 
  onKeyDown, 
  placeholder, 
  id, 
  autoComplete, 
  disabled, 
  autoFocus 
}: PasswordInputProps) {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="login-password-wrapper">
      <input
        type={showPassword ? "text" : "password"}
        className="login-input"
        placeholder={placeholder}
        id={id}
        autoComplete={autoComplete}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        disabled={disabled}
        autoFocus={autoFocus}
      />
      <button
        type="button"
        className="login-eye-toggle"
        onClick={() => setShowPassword(!showPassword)}
        aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
        tabIndex={-1}
      >
        {showPassword ? <EyeOffIcon /> : <EyeIcon />}
      </button>
    </div>
  );
}
